import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Grid,
  styled,
} from "@mui/material";
import { StudentListItem } from "../../../../types/StudentModel";
import EmailAvatar from "../../../../components/EmailAvatar";

interface StudentProfileDialogProps {
  open: boolean;
  onClose: () => void;
  student: StudentListItem | null;
}

const DetailLabel = styled(Typography)(({ theme }) => ({
  fontSize: "0.75rem",
  color: theme.palette.text.secondary,
}));

const StudentProfileDialog: React.FC<StudentProfileDialogProps> = ({
  open,
  onClose,
  student,
}) => {
  if (!student) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <EmailAvatar email={student.name} size={40} />
          <Typography variant="h6" sx={{ ml: 2 }}>
            Student Profile
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <DetailLabel>FULL NAME</DetailLabel>
            <Typography variant="body1" fontWeight={500}>
              {student.name}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <DetailLabel>EMAIL</DetailLabel>
            <Typography variant="body1">
              {student.email ||
                student.name.toLowerCase().replace(" ", ".") + "@example.com"}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <DetailLabel>STUDENT ID</DetailLabel>
            <Typography variant="body1">{student.id}</Typography>
          </Grid>
          {student.currentSchool && (
            <Grid item xs={12}>
              <DetailLabel>SCHOOL</DetailLabel>
              <Typography variant="body1">{student.currentSchool}</Typography>
            </Grid>
          )}
          {student.programName && (
            <Grid item xs={12}>
              <DetailLabel>PROGRAM</DetailLabel>
              <Typography variant="body1">{student.programName}</Typography>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default StudentProfileDialog;
